<template lang="pug">
v-slide-y-transition(mode="out-in")
  v-container(fluid, v-if="!isLoading()")
    v-form(ref="bookingForm", @submit="handleSubmit()")
      v-card.mb-2
        v-card-title
          h3.headline Cliente
        v-card-text
          v-autocomplete(
            :label="$t('Cliente')",
            v-model="booking.user",
            return-object,
            :rules="validation.required",
            :items="users",
            item-text="showName"
          )
          v-text-field(
            :label="$t('Cliente final')",
            v-model="booking.finalCustomer",
            :rules="validation.required",
            required,
            v-if="userIsAgency()"
          )

        v-card-title
          h3.headline Notificaciones
        v-card-text
          v-checkbox(
            label="Notificar al cliente",
            v-model="booking.notifyChangesToCustomer"
          )
          v-checkbox(
            label="Notificar a los alojamientos",
            v-model="booking.notifyChangesToAccommodationOwner"
          )

        v-card-title
          h3.headline Estancias
            v-btn.ml-2(
              color="primary",
              text,
              @click="addAccommodation = !addAccommodation"
            ) Añadir estancia

        v-card-text
          v-data-table.elevation-1(
            :headers="detailsTableHeaders",
            :items="booking.details",
            hide-default-footer,
            disable-pagination,
            :sort="{}"
          )
            template(v-slot:item.description="{item}")
              strong {{ item.description }}
              br
              small(v-html="nl2br(item.notes)")
            template(v-slot:item.fromDate="{item}") {{ formatDate(item.fromDate) }}
            template(v-slot:item.toDate="{item}") {{ formatDate(item.toDate) }}
            template(v-slot:item.total="{item}") {{ item.total | currency }}
            template(v-slot:item.options="{item}")
              v-btn(
                color="error",
                text,
                icon,
                @click="removeFromBooking(item)"
              )
                v-icon delete

        v-card-title
          h3.headline Extras
            v-btn.ml-2(color="primary", text, @click="addExtra()") Añadir extra
        v-card-text
          v-data-table.elevation-1(
            :headers="extraTableHeaders",
            :items="booking.extras",
            hide-default-footer,
            disable-pagination,
            :sort="{}"
          )
            template(v-slot:item.description="{ index }")
              v-text-field(v-model="booking.extras[index].description")
            template(v-slot:item.price="{ index }")
              v-text-field(
                v-model="booking.extras[index].price",
                suffix="€",
                @input="calculateExtraPrice(index)"
              )
            template(v-slot:item.quantity="{ index }")
              v-text-field(
                v-model="booking.extras[index].quantity",
                @input="calculateExtraPrice(index)"
              )
            template(v-slot:item.total="{ item }") {{ item.total | currency }}
            template(v-slot:item.options="{ item }")
              v-btn(
                color="error",
                text,
                icon,
                @click="removeFromBooking(item)"
              )
                v-icon delete

          h4.display-3.red--text.pt-3.text-xs-right {{ booking.total | currency }}

        v-card-actions
          v-btn(color="red", dark, @click="$router.push('/bookings')") Cancelar
          v-spacer
          v-btn(color="primary", :disabled="!booking.total", type="submit") Guardar

    v-dialog(:value="addAccommodation", persistent, style="max-width: 800px")
      v-card
        v-card-title
          h3.headline Añadiendo habitación
        v-card-text
          v-col
            v-autocomplete(
              :label="$t('Alojamiento')",
              v-model="accommodation",
              :items="accommodations",
              item-text="name",
              return-object,
              @input="handleAccommodationChange"
            )
            v-autocomplete(
              :label="$t('Habitación')",
              return-object,
              :disabled="accommodation === null && rooms.length < 1",
              :loading="this.loading.rooms",
              v-model="room",
              :items="rooms",
              item-text="name"
            )
            v-row(align="center")
              v-col(xs12, sm5)
                v-menu(
                  :close-on-content-click="false",
                  transition="scale-transition",
                  offset-y,
                  :nudge-right="40",
                  min-width="290px",
                  max-width="290px"
                )
                  template(v-slot:activator="{ on, attrs }")
                    v-text-field(
                      :value="formatDate(tmpRoom.fromDate)",
                      label="Desde",
                      prepend-icon="event",
                      readonly,
                      v-on="on",
                      v-bind="attrs"
                    )
                  v-date-picker(
                    locale="es",
                    :first-day-of-week="1",
                    no-title,
                    autosave,
                    v-model="tmpRoom.fromDate"
                  )
              v-col(xs12, sm5)
                v-menu(
                  :close-on-content-click="false",
                  transition="scale-transition",
                  offset-y,
                  :nudge-right="40",
                  min-width="290px",
                  max-width="290px"
                )
                  template(v-slot:activator="{ on, attrs }")
                    v-text-field(
                      :value="formatDate(tmpRoom.toDate)",
                      label="Hasta",
                      prepend-icon="event",
                      readonly,
                      v-on="on",
                      v-bind="attrs"
                    )
                  v-date-picker(
                    locale="es",
                    :first-day-of-week="1",
                    no-title,
                    :min="nextDay(tmpRoom.fromDate)",
                    reactive,
                    v-model="tmpRoom.toDate"
                  )
              v-col(xs12, sm2)
                v-text-field.ml-3.pr-3(
                  :label="$t('Pax')",
                  v-model="tmpRoom.pax"
                )
              v-btn(
                color="info",
                @click="calculatePrices()",
                :disabled="!hasDataEnoughForCalculate()"
              ) Obtener precios
          v-col(v-if="loading.calculate")
            v-row.my-6(align="center", justify="center")
              v-progress-circular(
                indeterminate,
                color="primary",
                :size="64",
                :width="2"
              )

          v-col(v-else)
            v-data-table.elevation-1(
              :headers="pricesTableHeader",
              sort="name ASC",
              :items="pricing",
              hide-default-footer,
              disable-pagination
            )
              template(v-slot:item.night="{ item }") {{ formatDate(item.date) }}
              template(v-slot:item.price="{ item, index }")
                v-text-field(v-model="pricing[index].price", suffix="€")

            v-textarea.mt-4(
              :label="$t('Notas')",
              v-model="tmpNotes",
              required,
              hint="Políticas de cancelación / servicios del alojamiento..."
            )
            h4.display-4.red--text.pt-3.text-xs-right {{ getTotal() | currency }}
        v-card-actions
          v-btn(color="error", @click="closeAddToBooking()") Cancelar
          v-spacer
          v-btn(
            color="success",
            @click="addToBooking()",
            v-if="pricing.length > 0"
          ) Añadir a la reserva

  v-container(fluid, fill-height, v-else)
    v-row(align="center", justify="center")
      v-progress-circular(
        indeterminate,
        color="primary",
        :size="128",
        :width="2"
      )
</template>

<script>
import validation from '@/utils/validation';
import moment from 'moment';
import { nl2br } from '@/utils/filters';

const emptyBooking = () => {
  const booking = {
    id: null,
    user: null,
    finalCustomer: null,
    accommodation: null,
    fromDate: null,
    toDate: null,
    details: [],
    extras: [],
    total: null,
  };
  return booking;
};

const emptyExtra = () => {
  const extra = {
    description: null,
    price: 0,
    quantity: 1,
    total: 0,
  };
  return extra;
};

export default {
  data() {
    return {
      addAccommodation: false,
      booking: {},
      accommodations: [],
      rooms: [],
      room: null,
      accommodation: null,
      users: [],
      pricing: [],
      pricingTotal: 0,
      extraTableHeaders: [
        {
          text: 'Descripción',
          align: 'left',
          value: 'description',
        },
        {
          text: 'Precio',
          align: 'left',
          value: 'price',
          width: 120,
        },
        {
          text: 'Unidades',
          align: 'left',
          value: 'quantity',
          width: 120,
        },
        {
          text: 'Total',
          align: 'right',
          value: 'total',
          width: 120,
        },
      ],
      pricesTableHeader: [
        {
          text: 'Noche',
          align: 'left',
          sortable: true,
          value: 'night',
        },
        {
          text: 'Precio',
          align: 'right',
          sortable: true,
          value: 'price',
          width: '200px',
        },
      ],
      detailsTableHeaders: [
        {
          text: 'Descripción',
          align: 'left',
          value: 'description',
          width: '400px',
        },
        {
          text: 'Desde',
          align: 'left',
          value: 'fromDate',
        },
        {
          text: 'Hasta',
          align: 'left',
          value: 'toDate',
        },
        {
          text: 'Precio',
          align: 'right',
          value: 'price',
        },
        {
          text: 'Opciones',
          align: 'right',
          sortable: false,
          value: 'options',
        },
      ],
      loading: {
        rooms: false,
        saving: false,
        booking: false,
        calculate: false,
        users: false,
        accommodations: false,
      },
      tmpNotes: null,
      tmpRoom: {
        fromDate: null,
        toDate: null,
        pax: null,
      },
      validation,
    };
  },
  created() {
    this.fetchData();
  },
  methods: {
    nl2br,
    isLoading() {
      return (
        this.loading.saving ||
        this.loading.booking ||
        this.loading.users ||
        this.loading.accommodations
      );
    },
    fetchData() {
      this.loading.booking = true;
      this.loading.accommodations = true;
      this.loading.users = true;

      if (this.$route.params.id) {
        api
          .get(`/bookings/${this.$route.params.id}`)
          .then((res) => {
            this.booking = res.data;
          })
          .catch(this.handleError)
          .finally(() => {
            this.loading.booking = false;
            this.setupUser();
          });
      } else {
        this.booking = Object.assign({}, emptyBooking());
        this.loading.booking = false;
      }

      api
        .get('/users')
        .then((res) => {
          this.users = res.data;
          this.users.map((user) => {
            const u = user;
            if (u.info) {
              if (u.info.commercialName) {
                u.showName = u.info.commercialName;
              } else if (u.info.fiscalName) {
                u.showName = u.info.showName;
              } else {
                u.showName = u.email;
              }
              if (u.info.commercialChain && u.info.commercialChain.name) {
                u.showName += ` - ${u.info.commercialChain.name}`;
              }
            } else {
              u.showName = u.email;
            }
            return u;
          });
        })
        .catch(this.handleError)
        .finally(() => {
          this.setupUser();
          this.loading.users = false;
        });

      api
        .get('/accommodations')
        .then((res) => {
          this.accommodations = res.data;
        })
        .catch(this.handleError)
        .finally(() => {
          this.loading.accommodations = false;
        });
    },
    handleAccommodationChange() {
      this.rooms = this.accommodation.rooms;
    },
    setupUser() {
      if (this.users.length > 0 && this.booking.user) {
        this.booking.user = this.users.filter(
          a => a.id === this.booking.user.id,
        )[0];
        this.$forceUpdate();
      }
    },
    formatDate(date) {
      if (date) {
        const [year, month, day] = date.split('-');
        return `${day}/${month}/${year}`;
      }
      return date;
    },
    nextDay(date) {
      if (date) {
        const obj = new Date(date);
        obj.setDate(obj.getDate() + 1);
        return obj.toISOString().split('T')[0];
      }
      return date;
    },
    userIsAgency() {
      if (this.booking.user) {
        return this.booking.user.roles.indexOf('AGENCY') > -1;
      }
      return false;
    },
    hasDataEnoughForCalculate() {
      return (
        this.accommodation &&
        this.room &&
        this.tmpRoom.fromDate &&
        this.tmpRoom.toDate &&
        this.tmpRoom.pax
      );
    },
    calculatePrices() {
      this.loading.calculate = true;
      api
        .post('/bookings/calculate', {
          accommodationId: this.accommodation.id,
          roomId: this.room.id,
          fromDate: this.tmpRoom.fromDate,
          toDate: this.tmpRoom.toDate,
        })
        .then((res) => {
          this.pricing = res.data.nightPrices;
          this.pricingTotal = res.data.total;
          this.tmpNotes = [this.accommodation.notes, this.room.notes]
            .filter(a => a)
            .join('\n');
        })
        .catch(this.handleError)
        .finally(() => {
          this.loading.calculate = false;
        });
    },
    addExtra() {
      this.booking.extras.push(emptyExtra());
    },
    getTotal() {
      if (this.pricing.length > 0) {
        return this.pricing
          .map(a => parseFloat(a.price))
          .reduce((a, b) => a + b);
      }
      return 0;
    },
    removeFromBooking(item) {
      const index = this.booking.details.indexOf(item);
      if (item.id) {
        api
          .delete(`/bookings/${this.booking.id}/details/${item.id}`)
          .then(() => {
            this.booking.details.splice(index, 1);
            this.recalculateTotal();
          })
          .catch(this.handleError);
      } else {
        this.booking.details.splice(index, 1);
        this.recalculateTotal();
      }
    },
    calculateExtraPrice(index) {
      this.booking.extras[index].total =
        parseFloat(this.booking.extras[index].price) *
        parseFloat(this.booking.extras[index].quantity);
      this.recalculateTotal();
    },
    recalculateTotal() {
      this.booking.total =
        this.booking.details.reduce((a, d) => a + d.total, 0) +
        this.booking.extras.reduce((a, b) => a + b.total, 0);
    },
    addToBooking() {
      this.booking.details.push({
        room: {
          id: this.room.id,
        },
        accommodation: {
          id: this.accommodation.id,
        },
        description: `${this.accommodation.name}, ${this.room.name}`,
        notes: this.tmpNotes,
        fromDate: this.tmpRoom.fromDate,
        toDate: this.tmpRoom.toDate,
        pax: this.tmpRoom.pax,
        nights: this.getNights(this.tmpRoom.fromDate, this.tmpRoom.toDate),
        price: this.getTotal(),
        quantity: 1,
        total: this.getTotal(),
      });
      this.recalculateTotal();
      this.closeAddToBooking();
    },
    getNights(fromDate, toDate) {
      return moment(toDate).diff(moment(fromDate), 'days');
    },
    closeAddToBooking() {
      this.addAccommodation = false;
      this.accommodation = null;
      this.room = null;
      this.tmpRoom.fromDate = null;
      this.tmpRoom.toDate = null;
      this.pricing = [];
      this.pricingTotal = 0;
      this.tmpNotes = null;
    },
    clearBooking() {
      this.room = null;
      this.booking.details = [];
    },
    handleSubmit() {
      if (
        this.$refs.bookingForm.validate() &&
        this.booking.details.length > 0 &&
        this.booking.total > 0
      ) {
        this.loading.saving = true;
        if (this.booking.id === null) {
          api
            .post(
              '/bookings',
              Object.assign({}, this.booking, {
                user: { id: this.booking.user.id },
              }),
            )
            .then(() => {
              this.$router.push('/bookings');
            })
            .catch(this.handleError)
            .finally(() => {
              this.loading.saving = false;
            });
        } else {
          api
            .put(
              `/bookings/${this.booking.id}`,
              Object.assign({}, this.booking, {
                user: { id: this.booking.user.id },
              }),
            )
            .then(() => {
              this.$router.push('/bookings');
            })
            .catch(this.handleError)
            .finally(() => {
              this.loading.saving = false;
            });
        }
      }
    },
    handleError(err) {
      // eslint-disable-next-line no-console
      console.error(err);
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/pages/Bookings/BookingForm.vue